import { html, customElement, state } from '@oskecare/fe-utilities/lib/LitElement/index.js';
import OrangeL2Widget from '@oskecare/fe-utilities/lib/OrangeL2Widget';

@customElement('osk-footer-wrapper')
class Footer extends OrangeL2Widget {
  /**
   * @type {boolean}
   */
  @state()
  accessor _didomiReady = false;

  get personalizationHandlers() {
    return {
      ...super.personalizationHandlers,
      'footer.didomi': ({ didomiReady }) => {
        this._didomiReady = didomiReady;
      },
    };
  }

  /**
   * Disables shadowRoot for this element.
   */
  createRenderRoot() {
    return this;
  }

  render() {
    return html` <osk-footer ?didomi-ready=${this._didomiReady}></osk-footer> `;
  }
}

export default Footer;
